import { internalApi } from '@/utils/request'; 
import { toastr } from 'react-redux-toastr';

export const fetchOnboardingStatusApi = async () => {
  try {
    const response = await internalApi.get('/business/onboarding/status');
    return response.data || response;
  } catch (error) {
    console.error('[OnboardingAPI] Fetch status failed', error);
    return null;
  }
};

// FIX: Accept stage argument
export const advanceOnboardingStageApi = async (stage?: number) => {
  try {
    // Pass stage in body if provided
    const body = stage !== undefined ? { stage } : {};
    const response = await internalApi.post('/business/onboarding/advance', body);
    return response.data || response;
  } catch (error) {
    console.error('[OnboardingAPI] Advance stage failed', error);
    toastr.error('Error', 'Failed to save progress.');
    throw error;
  }
};